// Simple logger that logs to console in development, silent in production.
// Used for non-critical errors (polling fetches, optional API calls) that
// shouldn't crash the UI but are still useful to know about during debugging.
const isDev = process.env.NODE_ENV !== 'production';

export const logError = (context, error) => {
  if (isDev) {
    console.warn(`[${context}]`, error?.message || error);
  }
};
